<div class="w-full">
  <p-table
    [value]="priceBandFormArrayControls"
    [tableStyle]="{ width: '100%' }"
    class="p-datatable-gridlines p-datatable-sm w-full"
  >
    <ng-template #header>
      <tr>
        <th colspan="4">{{ 'organisationTypes.' + PublisherType | translate }}</th>
      </tr>
      <tr>
        <th colspan="2" class="text-center">{{ 'userCount' | translate }}</th>
        <th>{{ 'pricePerUser' | translate }}({{ Currency }})</th>
        @if (showDiscountedPrice) {
          <th>{{ 'discounted_price_per_user' | translate }}({{ Currency }})</th>
        }
        @if (!isReadOnly) {
          <th>{{ 'actions' | translate }}</th>
        }
      </tr>
    </ng-template>
    <ng-template #body let-priceBandForm let-i="rowIndex">
      <ng-container [formGroup]="priceBandForm">
        @if (i !== getLastIndex()) {
          <tr>
            <td class="text-center">
              <span class="lower-number number-width"> {{ getLowerLimitValue(i) | number: '1.0' : 'en-US' }}</span>
            </td>
            <td>
              <p-inputNumber
                [min]="i === 0 ? 1 : getLastUpperLimitValue(i) + 1"
                type="number"
                id="upperLimit{{ i }}"
                class="text-center"
                formControlName="upperLimitUserCount"
                [max]="MAX_UPPER_LIMIT_COUNT"
                (onInput)="upperLimitChange(i, priceBandForm)"
                [readonly]="isReadOnly ? true : null"
              />
              @if (
                priceBandForm.get('upperLimitUserCount').errors?.required ||
                priceBandForm.get('upperLimitUserCount')?.value <= priceBandForm.get('lowerLimitUserCount')?.value
              ) {
                <small class="p-error"> {{ 'upperlimitError1' | translate }} </small>
              }
              @if (priceBandForm.get('upperLimitUserCount').hasError('max')) {
                <small class="p-error"> {{ 'price_band_max_length_err' | translate }} </small>
              }
            </td>
            <td>
              <input
                type="number"
                min="0.0001"
                pInputText
                class="text-center ppu-width"
                formControlName="pricePerUser"
                pattern="^\d+(\.\d{1,4})?$"
                [max]="MAX_PRICE_PER_USER"
                required
                [readonly]="isReadOnly ? true : null"
              />
              @if (priceBandForm.get('pricePerUser')?.errors?.min) {
                <small class="p-error"> {{ 'price_per_user_min' | translate }} </small>
              }
              @if (priceBandForm.get('pricePerUser')?.errors?.required) {
                <small class="p-error"> {{ 'pricePerUser' | translate }} {{ 'isRequired' | translate }} </small>
              }
              @if (priceBandForm.get('pricePerUser').hasError('max')) {
                <small class="p-error"> {{ 'price_per_user_max_length_err' | translate }} </small>
              }
            </td>
            @if (showDiscountedPrice) {
              <td>
                <input
                  type="number"
                  min="0"
                  pInputText
                  class="text-center number-width"
                  formControlName="discountedPricePerUser"
                  [readonly]="true"
                />
              </td>
            }
            @if (!isReadOnly) {
              <td>
                @if (i === priceBandFormArrayControls.length - 2) {
                  <button
                    pButton
                    type="button"
                    icon="pi pi-plus-circle"
                    class="p-button-rounded p-button-success p-button-text"
                    (click)="addPriceBand()"
                  ></button>
                }
                <button
                  pButton
                  type="button"
                  icon="pi pi-minus-circle"
                  class="p-button-rounded p-button-danger p-button-text"
                  (click)="removePriceBand(i)"
                  [disabled]="i === 0"
                ></button>
              </td>
            }
          </tr>
        }
        @if (i === getLastIndex()) {
          <tr>
            <td colspan="2" class="text-center">
              >=
              {{
                priceBandFormArrayControls[priceBandFormArrayControls.length - 2]?.get('upperLimitUserCount')?.value + 1
                  | number: '1.0' : 'en-US'
              }}
            </td>
            <td>
              <input
                min="0.0001"
                type="number"
                pInputText
                class="text-center ppu-width"
                formControlName="pricePerUser"
                pattern="^\d+(\.\d{1,4})?$"
                [max]="MAX_PRICE_PER_USER"
                required
                [readonly]="isReadOnly ? true : null"
              />
              @if (priceBandForm.get('pricePerUser')?.errors?.min) {
                <small class="p-error"> {{ 'price_per_user_min' | translate }} </small>
              }
              @if (priceBandForm.get('pricePerUser')?.errors?.required) {
                <small class="p-error"> {{ 'pricePerUser' | translate }} {{ 'isRequired' | translate }} </small>
              }
              @if (priceBandForm.get('pricePerUser').hasError('max')) {
                <small class="p-error"> {{ 'price_per_user_max_length_err' | translate }} </small>
              }
            </td>
            @if (showDiscountedPrice) {
              <td>
                <input
                  type="number"
                  min="0"
                  pInputText
                  class="text-center number-width"
                  formControlName="discountedPricePerUser"
                  [readonly]="true"
                />
              </td>
            }
          </tr>
        }
      </ng-container>
    </ng-template>
    <!-- Special row for condition -->
    <ng-template #footer>
      @if (!isReadOnly) {
        <tr>
          <td colspan="4" class="text-center">
            @if (isEditMode) {
              <button
                pButton
                pRipple
                (click)="onConfirmUpdate()"
                label="{{ 'update' | translate }}"
                icon="pi pi-file"
                class="mt-2"
                [disabled]="this.priceBandFormArray.invalid"
              ></button>
            }
          </td>
        </tr>
      }
    </ng-template>
  </p-table>
</div>
<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
